module.exports = __webpack_public_path__ + "static/media/messenger_2x.980b1b3f.png";